import { put } from 'redux-saga/effects';
import Notification from 'antd/lib/notification';

// internal
import * as Action from '@app/store/typings/actions/zone.d';
import * as Service from '@app/services/zone';
import { ResponseListData } from '@app/typings/services/service.d';
import { handleError } from '@app/utils/service';
import { useZoneStore } from '@app/store/zone';

export function* fetchZones(action: Action.FetchZone) {
  // const query = getQueryString()

  try {
    const { data } = yield Service.fetchZone(action.payload.brand, action.payload.project);
    if (data.success) {
      yield put<Action.SetZones>({
        type: 'KEY_ZONE_SET_DATA',
        payload: {
          data: data.data || [],
        },
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchDataSelect(action: Action.FetchSelectZone) {
  try {
    const { data } = yield Service.fetchZoneSelect(action.payload.brand, action.payload.project);
    if (data.success) {
      yield put<Action.ZoneType>({
        type: 'KEY_ZONE_SELECT_SET_DATA',
        payload: data.data.map((value: ResponseListData) => {
          return { value: value._id, label: value.name };
        }),
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchCreate(action: Action.FormCreate) {
  try {
    const { name, brand, project } = action.payload;
    const { data } = yield Service.fetchCreate(name, brand, project);

    if (data.success) {
      yield put<Action.FetchZone>({
        type: 'KEY_ZONE_FETCH',
        payload: { brand: brand, project: project },
      });
      yield put<Action.SwitchModalCreate>({
        type: 'KEY_ZONE_MODAL_CREATE',
      });
      Notification.success({
        message: 'Alert',
        description: 'Create zone name: "' + name + '" successful',
      });
    }
  } catch (error: any) {
    const err = handleError(error);
    if (err.code === 'KS009') {
      Notification.error({
        message: 'Alert',
        description: 'Name already exists',
      });
    } else {
      Notification.error({
        message: 'Error',
        description: error.response.data.message,
      });
    }
  }
  useZoneStore.getState().onList();
}
